import React, { useEffect, useState, useRef } from 'react';
import $ from 'jquery';
import { Icon } from '@iconify/react';
import { useUserProfile } from '../masterLayout/MasterLayoutBody';
import { uploadVectorFile } from '../api/vector-uploadAPI';
import {
  getPrompts,
  createPrompts,
  updatePrompts,
  deletePrompts
} from '../api/promptsAPI';

const PromptListLayer = () => {
  const userProfile = useUserProfile();
  const [promptList, setPromptList] = useState([]);
  const [newPrompt, setNewPrompt] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});

  const tableRef = useRef(null);
  const dtRef = useRef(null);


  const fetchPrompts = async () => {
    try {
      const data = await getPrompts();
      setPromptList(data);
    } catch (err) {
      console.error('Error fetching prompts:', err);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newPrompt.name?.trim()) newErrors.name = 'Prompt title is required';
    if (!newPrompt.prompt?.trim()) newErrors.prompt = 'Prompt content is required';
    if (!editingId && !newPrompt.controller?.trim()) newErrors.controller = 'Controller is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

    const handleVectorUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
        const data = await uploadVectorFile(file);
        alert(`✅ Uploaded to Vector Store: ${data.vectorStoreId}`);
    } catch (err) {
        console.error('Vector file upload failed:', err);
        alert('❌ Upload failed: ' + err.message);
    }
    };

  useEffect(() => {
    fetchPrompts();
    // fetchData("getAll", { apiName: "prompts" }, setPromptList);
    // fetchData("getAll", { apiName: "user-profile" }, setUserProfile);
  }, []);

  useEffect(() => {
    if (dtRef.current) {
      dtRef.current.destroy();
      dtRef.current = null;
    }
    if (promptList.length > 0) {
      dtRef.current = $(tableRef.current).DataTable({
        pageLength: 25,
        dom: 'rtp',
        responsive: false,
        language: {
          paginate: { first: '', last: '', next: '', previous: '' },
        },
      });
    }
    return () => {
      if (dtRef.current) {
        dtRef.current.destroy(true);
        dtRef.current = null;
      }
    };
  }, [promptList]);

  useEffect(() => {
    if (dtRef.current) {
      dtRef.current.search(searchTerm).draw();
    }
  }, [searchTerm]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPrompt((prev) => ({ ...prev, [name]: value }));
  };

  const handleEdit = (item) => {
    setNewPrompt(item);
    setEditingId(item.id);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this prompt?')) return;
    try {
      await deletePrompts(id);
      if (dtRef.current) {
        dtRef.current.destroy();
        dtRef.current = null;
      }
      await fetchPrompts()
    } catch (error) {
      console.error('Error deleting prompt:', error);
    }
  };

  const handleSave = async () => {
    if (!validateForm()) return;
    try {
      const cleanPayload = {};
      for (const key in newPrompt) {
        if (newPrompt[key] !== null && typeof newPrompt[key] !== 'object') {
          cleanPayload[key] = newPrompt[key];
        }
      }

      if (editingId) {
        await updatePrompts(editingId, cleanPayload);
      } else {
        await createPrompts(cleanPayload);
      }

      setShowModal(false);
      setEditingId(null);
      if (dtRef.current) {
        dtRef.current.destroy();
        dtRef.current = null;
      }

      setNewPrompt({});
      await fetchPrompts();
    } catch (error) {
      console.error('Error saving prompt:', error);
    }
  };

  return (
    <div className="card h-100 p-0 rounded-0">
        <div className="card-header d-flex justify-content-between align-items-center p-3">
            <p className="text-xl fw-bold mb-0">Vector File Loader</p>
        </div>
        <div className="card-body p-0">
          <div className="mt-4">
            <label className="form-label">Upload VectorStore .json</label>
            <input type="file" accept=".json" className="form-control" onChange={handleVectorUpload} />
          </div>
        </div>
        <div className="card-header d-flex justify-content-between align-items-center p-3">
          <p className="text-xl fw-bold mb-0">Prompt Table</p>
          <div className="d-flex align-items-center gap-2">
            <input
            type="text"
            className="form-control w-auto"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            />
            {userProfile?.privileges?.includes('prompts:create') && (
            <button
                className="btn btn-primary text-sm btn-sm px-16 py-12 radius-4 d-flex align-items-center gap-2"
                onClick={() => {
                setNewPrompt({});
                setEditingId(null);
                setShowModal(true);
                }}
            >
                <Icon icon="ic:baseline-plus" className="icon text-xl" />
                Add Prompt
            </button>
            )}
          </div>
        </div>

      <div className="card-body p-0">
        <div>
          <table 
            className="table bordered-table mb-0" 
            style ={{ minWidth:"100px"}} ref={tableRef}
            >
            <thead>
              <tr>
                <th>Title</th>
                <th>Prompt</th>
                <th>Controller</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {promptList.map((item) => (
                <tr key={item.id}>
                  <td><strong>{item.name}</strong></td>
                  <td style={{ padding: 0 }}>
                    <div style={{ 
                        whiteSpace: 'pre-wrap', 
                        wordBreak: 'break-word', 
                        maxHeight: '200px', 
                        overflowY: 'scroll',
                        width: '700px',
                        fontFamily: 'Courier, monospace',
                        padding: '8px',
                        borderStyle: 'solid',
                        borderColor: '#ddd', 
                        borderWidth: '1px',
                    }}>
                        {item.prompt}
                    </div>
                  </td>
                  <td>{item.controller}</td>
                  <td>
                    <div className="d-flex gap-2">
                      {userProfile?.privileges?.includes('prompts:update') && (
                        <button
                          className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                          onClick={() => handleEdit(item)}
                        >
                          <Icon icon="ic:baseline-edit" className="icon text-xl line-height-1" />
                        </button>
                      )}
                      {userProfile?.privileges?.includes('prompts:delete') && (
                        <button
                          className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                          onClick={() => handleDelete(item.id)}
                        >
                          <Icon icon="ic:baseline-delete-outline" className="icon text-xl line-height-1" />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content" style={{ height: "90vh"}}>
              <div className="modal-header">
                <h5 className="modal-title">{editingId ? 'Edit Prompt' : 'New Prompt'}</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)} />
              </div>
              <div className="modal-body">
                <div className="row g-3 h-100">
                  <div className="col-md-12">
                    <label className="form-label">Prompt Title *</label>
                    <input
                      className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                      name="name"
                      value={newPrompt.name || ''}
                      onChange={handleInputChange}
                    />
                    {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Controller {!editingId && '*'}</label>
                    <input
                      className={`form-control ${errors.controller ? 'is-invalid' : ''}`}
                      name="controller"
                      value={newPrompt.controller || ''}
                      onChange={handleInputChange}
                      disabled={Boolean(editingId)}
                    />
                    {errors.controller && <div className="invalid-feedback">{errors.controller}</div>}
                  </div>
                  <div className="col-md-12" style={{height: "calc(100% - 120px)"}}>
                    <label className="form-label">Prompt Content *</label>
                    <textarea
                      className={`form-control ${errors.prompt ? 'is-invalid' : ''}`}
                      style={{ 
                        fontFamily: 'courier',
                        height: "100%"
                      }}
                      name="prompt"
                      value={newPrompt.prompt || ''}
                      onChange={handleInputChange}
                    />
                    {errors.prompt && <div className="invalid-feedback">{errors.prompt}</div>}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                <button className="btn btn-primary" onClick={handleSave}>Save</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PromptListLayer;
